export const HEADER_TITLE = 'Welcome to Your HFS Loan Portal';
